export class CloudFile {
  public uid_clear: string = '';
  constructor(
    public uid: string,
    public file: File | null,
    public description: string = '',
    public isPrivate: boolean = false,
    public docType: string = '',
    public validUntil: string = ''
  ) {
    this.uid_clear = uid.split('.')[0];
  }
}
